import getNoticeDetail from '@/api/get-notice-detail';
function getDefaultOptions() {
  return {
    id: '',
    type: '',
    crypto: '',
    fiatCurrency: '',
    maxPercentage: '',
    minPercentage: '',
    maxGap: '',
    minGap: '',
    alertCount: '',
    alertGap: '',
    reference: '',
  };
}
export const noticeTempState = {
  noticeTemp: getDefaultOptions(),
  noticeStore: getDefaultOptions(),
};
export const noticeTempMutations = {
  setNoticeTemp(state, obj) {
    if (obj.isNew !== undefined) {
      if (obj.isNew) {
        state.noticeTemp = getDefaultOptions();
        return;
      }
    }
    Object.assign(state.noticeTemp, obj);
  },
  setNoticeStore(state, obj) {
    if (obj.isNew !== undefined) {
      if (obj.isNew) {
        state.noticeStore = getDefaultOptions();
        return;
      }
    }
    Object.assign(state.noticeStore, obj);
  },
};

export const noticeTempActions = {
  updateNoticeStore({ commit }, { id }) {
    return getNoticeDetail(id).then(data => {
      const d = data.data;
      const obj = {
        id: d.id,
        type: d.type,
        crypto: d.asset.id,
        fiatCurrency: d.legalCurrency.id,
        alertCount: d.alertCount,
        alertGap: d.alertGap,
        reference: d.currType === 'exinone' ? 1 : 0,
      };
      if (d.currType == 'exinone') {
        obj.maxGap = d.maxPercentage;
        obj.minGap = d.minPercentage;
      } else {
        obj.maxPercentage = d.maxPercentage;
        obj.minPercentage = d.minPercentage;
      }
      commit('setNoticeStore', obj);
    });
  },
};
